// extracted by mini-css-extract-plugin
export default {"wrapped":"input__wrapped-BdMO_","simple":"input__simple-u7fym","error":"input__error-XENmY","normal":"input__normal-oqzqZ","children":"input__children-XXJ0z"};